import React, { useContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Checkbox } from '@mantine/core';
import { Context as RegistrationAdminContext } from '../../../providers/RegistrationAdminProvider';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';
import { triggerNotification } from '../../../helpers/notificationHelper';
import AppText from '../../common/AppText';

const SendOrderReceiptModal = ({
  isAdminViewing,
  isOpen,
  onClose,
  regCart,
  pkRegCarts
}) => {
  const { resendRegCartOrderReceipts } = useContext(RegistrationAdminContext);
  const [formState, setFormState] = useState({
    sendCopy: false,
    sendToCustomer: false,
    sendToSecondaryContacts: true,
    loading: false
  });

  const cartSecondaryEmails = regCart
    ? regCart.regCartProducts
        .flatMap((p) =>
          p.regFormSubmission.regFormSubmissionPersonContacts.map(
            (c) => c.email
          )
        )
        .filter(Boolean)
    : [];

  useEffect(() => {
    if (isOpen) {
      setFormState({
        sendCopy: false,
        sendToCustomer: false,
        sendToSecondaryContacts: true,
        loading: false
      });
    }
  }, [isOpen]);

  return (
    <ResponsiveModal
      formSectionProps={{
        isLoading: formState.loading,
        isSubmitDisabled:
          isAdminViewing && !formState.sendCopy && !formState.sendToCustomer,
        onCancel: onClose,
        onSubmit: () => {
          setFormState({
            ...formState,
            loading: true
          });

          const sendToCustomer = isAdminViewing
            ? formState.sendToCustomer
            : true;
          const defaultRequestData = {
            sendCopy: isAdminViewing ? formState.sendCopy : false,
            sendToCustomer,
            sendToSecondaryContacts:
              sendToCustomer && formState.sendToSecondaryContacts
          };

          resendRegCartOrderReceipts(
            regCart
              ? [
                  {
                    pkRegCart: regCart.pkRegCart,
                    ...defaultRequestData
                  }
                ]
              : pkRegCarts?.map((pk) => ({
                  pkRegCart: pk,
                  ...defaultRequestData
                })) || [],
            () => {
              triggerNotification('Receipt Sent!', 'Success', 'green');
              onClose();
            },
            (e) => {
              triggerNotification(e);
              setFormState({
                ...formState,
                loading: false
              });
            }
          );
        },
        submitTitle: 'Send receipt'
      }}
      isNewModalStyle
      isOpen={isOpen}
      onClose={onClose}
      title="Email Receipt"
    >
      {isAdminViewing ? (
        <AppStack style={{ gap: 10 }}>
          <AppText
            style={{
              fontSize: 14,
              color: '#666',
              textAlign: 'center',
              fontStyle: 'italic'
            }}
          >
            Select who to send the receipt to;
          </AppText>

          <AppStack style={{ gap: 20 }}>
            <Checkbox
              checked={formState.sendToCustomer}
              disabled={formState.loading}
              label="Customer mailbox"
              onChange={(e) =>
                setFormState({
                  ...formState,
                  sendToCustomer: e.target.checked
                })
              }
            />

            {formState.sendToCustomer &&
              (!regCart || cartSecondaryEmails.length > 0) && (
                <Checkbox
                  checked={formState.sendToSecondaryContacts}
                  disabled={formState.loading}
                  label="Include secondary emails"
                  onChange={(e) =>
                    setFormState({
                      ...formState,
                      sendToSecondaryContacts: e.target.checked
                    })
                  }
                />
              )}

            <Checkbox
              checked={formState.sendCopy}
              disabled={formState.loading}
              label="Your own mailbox"
              onChange={(e) =>
                setFormState({
                  ...formState,
                  sendCopy: e.target.checked
                })
              }
            />
          </AppStack>
        </AppStack>
      ) : (
        <AppStack>
          <AppText style={{ textAlign: 'center' }}>
            Receipt will be sent to your mailbox.
          </AppText>

          {cartSecondaryEmails.length > 0 && (
            <Checkbox
              checked={formState.sendToSecondaryContacts}
              disabled={formState.loading}
              label="Include secondary emails"
              onChange={(e) =>
                setFormState({
                  ...formState,
                  sendToSecondaryContacts: e.target.checked
                })
              }
            />
          )}
        </AppStack>
      )}
    </ResponsiveModal>
  );
};

SendOrderReceiptModal.propTypes = {
  isAdminViewing: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  pkRegCarts: PropTypes.array,
  regCart: PropTypes.object
};
export default SendOrderReceiptModal;
